import React from 'react';
import { Plus } from 'lucide-react';
import ReviewCard from './ReviewCard';
import Reveal from './Reveal';

const ReviewsPage = ({ reviews, isAuthenticated, onEditReview, onDeleteReview, onOpenNewReview }) => {
  return (
    <div className="page py-12 md:py-16">
      <header className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:justify-between">
        <h1 className="page-title">Movie Reviews</h1>
        {isAuthenticated && (
          <button type="button" onClick={onOpenNewReview} className="btn-primary">
            <Plus size={18} strokeWidth={1.75} />
            Add Review
          </button>
        )}
      </header>

      {reviews.length === 0 ? (
        <div className="mt-12 max-w-xl rounded-xl bg-slate-900 p-8 ring-1 ring-white/10">
          <h2 className="text-xl font-semibold text-slate-50">No Reviews Yet</h2>
          <p className="mt-2 text-slate-400">
            {isAuthenticated
              ? "Use 'Add Review' to publish your first movie review."
              : 'Check back soon for new movie reviews!'}
          </p>
        </div>
      ) : (
        <div className="mt-8 divide-y divide-white/5 border-t border-white/5">
          {reviews.map((review) => (
            <Reveal key={review.id}>
              <ReviewCard
                review={review}
                isAdmin={isAuthenticated}
                onEdit={onEditReview}
                onDelete={onDeleteReview}
              />
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewsPage;
